import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-enrichment/utils/nav-context';

const ProductMasterDetailPage = lazy(
  () => import('~/features/catalog-enrichment/pages/product-master-detail-page'),
);

/** S8 — `from`/`back` carry where a cross-section link sent the user here, so the page can show
 *  an origin breadcrumb prefix and a "← Back to <origin>" chip instead of landing with no trace
 *  of the batch/queue/experiment that linked here. */
const searchSchema = z.object({
  ...navContextSearchSchema,
  /** Opens the product's version history sheet (linked from a listing's versions card). */
  versions: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/products/$productId',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { productId } = Route.useParams();
  const { versions } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ProductMasterDetailPage
        productId={productId}
        versionsOpen={!!versions}
        onVersionsOpenChange={(open) => {
          void navigate({
            search: (prev) => ({ ...prev, versions: open ? true : undefined }),
            replace: true,
          });
        }}
      />
    </Suspense>
  );
}
